import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import menuIndex from '@/views/menuIndex'
import guideIndex from '@/views/guideIndex'
import config_main from '@/views/config_main'
import robotmanager from '@/views/robotManager'
import guideFcode from '@/views/guide/guideFcode'
import guideAccount from '@/views/guide/guideAccount'
import guideRate from '@/views/guide/guideRate'
import guideContent from '@/views/guide/guideContent'
import guideError from '@/views/guide/guideError'
import Login from '@/views/login/Login'
import promoters from '@/views/promoters'
import generalizedReturn from '@/views/generalizedReturn'
import detailsOfCommission from '@/views/detailsOfCommission'
import lotteryGift from '@/views/lotteryGift'

let version = ''
if (window.electron) {
  version = window.electron.remote.app.getVersion()
} else {
  version = '1.4'
}

Vue.use(Router)
export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'menuindex',
      component: menuIndex,
      children: [
        {
          path: '/robotManager',
          name: 'robotManager',
          component: robotmanager,
          meta: {
            title: `机器人列表_小虎弟场控${version ? `_${version}` : ''}`
          }
        }
      ]
    },
    {
      path: '/',
      name: 'guideindex',
      component: guideIndex,
      children: [
        {
          path: '/guideFcode',
          name: 'guideFcode',
          component: guideFcode,
          meta: {
            title: `激活商业版_小虎弟场控${version ? `_${version}` : ''}`
          }
        },
        {
          path: '/guideAccount',
          name: 'guideAccount',
          component: guideAccount,
          meta: {
            title: `场控配置_小虎弟场控${version ? `_${version}` : ''}`
          }
        },
        {
          path: '/guideRate',
          name: 'guideRate',
          component: guideRate,
          meta: {
            title: `频率配置_小虎弟场控${version ? `_${version}` : ''}`
          }
        },
        {
          path: '/guideContent',
          name: 'guideContent',
          component: guideContent,
          meta: {
            title: `内容配置_小虎弟场控${version ? `_${version}` : ''}`
          }
        },
        {
          path: '/guideError',
          name: 'guideError',
          component: guideError,
          meta: {
            title: `下载客户端_小虎弟场控${version ? `_${version}` : ''}`
          }
        }
      ]
    },
    {
      path: '/',
      name: 'index',
      component: index,
      children: [
        {
          path: '/agent',
          name: 'agent',
          component: generalizedReturn,
          meta: {
            title: `推广返现_小虎弟场控${version ? `_${version}` : ''}`
          }
        },
        {
          path: '/details',
          name: 'details',
          component: detailsOfCommission,
          meta: {
            title: `佣金明细_小虎弟场控${version ? `_${version}` : ''}`
          }
        },
        {
          path: '/promoters',
          name: 'promoters',
          component: promoters,
          meta: {
            title: `代理商_小虎弟场控${version ? `_${version}` : ''}`
          }
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: `登录_小虎弟场控${version ? `_${version}` : ''}`
      }
    },
    {
      path: '/config',
      name: 'config',
      component: config_main,
      meta: {
        title: `插件配置_小虎弟场控${version ? `_${version}` : ''}`
      }
    },
    {
      path: '/lotterygift',
      name: 'lotterygift',
      component: lotteryGift,
      meta: {
        title: "绝版礼物"
      }
    }
  ]
})
